export default __webpack_public_path__ + "static/material_02-6feea390d0b818d240eb8cfd220e84f8.png";